import React, { useState, useContext, Component, createRef } from "react";
import CartContext from "./CartContext";
import { BlobServiceClient } from "@azure/storage-blob";
import { Link } from "react-router-dom";
import { Nav } from "react-bootstrap";
import { Navigate } from "react-router-dom";
import { LoadSpinner } from "./LoadSpinner";
import Swal from "sweetalert2";
import { Helmet } from "react-helmet";
import axios from "axios";

import { Row, Col, Table, Form, Button } from "react-bootstrap";

export default class Settings extends Component {
  static contextType = CartContext;
  constructor(props) {
    super(props);
    this.state = {};
  }

  ShowLoadSpinner = () => {
    this.setState({ loadSpinnerOpen: true });
  };

  HideLoadSpinner = () => {
    this.setState({ loadSpinnerOpen: false });
  };

  componentDidMount() {
    window.scrollTo(0, 0);
  }

  render() {
    if (this.context.userData.loginStatus != "active")
      return <Navigate to="/home" />;
    return (
      <>
        {this.state.loadSpinnerOpen && <LoadSpinner open="true" />}

        <div className="mx-0 px-1 bg-white w-100">
          <div className="row mt-2 mx-0 px-2">
            <div className="col-md-12">
              <h3 className="producttitlefontandsizeDesktop">
                <b>Settings</b>
              </h3>
              <br />
            </div>
          </div>
        </div>
      </>
    );
  }
}
